export enum BOOL_STRING {
  False = 'false',
  True = 'true',
}

export enum OpCode {
  Success,
  Noop,
}

export type ImageFormat = 'bmp' | 'gif' | 'jpeg' | 'png' | 'webp';

export interface ImageAsset {
  base64: string;
  format: ImageFormat | null;
}

/**
 * Map from image ID to its Base64 data and content-detected format.
 */
export type ImageMap = Map<string, ImageAsset>;
